import { render, staticRenderFns } from "./LanguageCategories.vue?vue&type=template&id=35cbf38b&scoped=true"
import script from "./LanguageCategories.vue?vue&type=script&lang=js"
export * from "./LanguageCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbf38b",
  null
  
)

export default component.exports